import { useSelector } from 'react-redux';
import { getTakeoverCampaignName } from 'modules/experiments/takeover/ducks/selectors';

import { StyledCampaignHeader } from './Styled';

export const ExperimentTakeoverHeader = () => {
  const campaignName = useSelector(getTakeoverCampaignName);
  return <StyledCampaignHeader>{campaignName}</StyledCampaignHeader>;
};
